import {isBrandPortal} from '@netx/core-cms-next/utils/isBrandPortal';
import {
	currentUserMeetsUserLevel,
	UserLevel,
} from '@netx/core-user-next/utils/currentUserMeetsUserLevel';
import {currentUserIsAdmin, permissionsEnabled, categoryPermissionChecker, PermissionName, PermissionMatrixName} from '@netx/core-permissions-next';
import {canEditCategory} from './canEditCategory';
import {type ICategory} from '../schema';

export const canAddCategory = (category?: ICategory) => {
	if (isBrandPortal()) return false;
	if (!currentUserMeetsUserLevel(UserLevel.MANAGER)) return false;

	if (permissionsEnabled()) {
		if (!category || category.categoryid === 1) return currentUserIsAdmin();
		return categoryPermissionChecker({
			category,
			permissionMatrixName: PermissionMatrixName.DELETE,
			permissionName: PermissionName.ADD_FOLDERS,
		});
	}

	return (
		// if no category is provided (why?) we assume they can...
		(!category || (category.recursivePermission && canEditCategory(category)))
	);
};
